// ============================================================
// Datei: src/components/AssignedShifts.jsx
// PURPOSE:
// Anzeige der eigenen Schichten im gleichen Dark-Glass-Style
// wie die ShiftOverview-Karten
// → CHRONOLOGISCH sortiert
// → MAXIMAL 3 SCHICHTEN
// → DELETE MIT BESTÄTIGUNG
// ============================================================

import React, { useState } from "react";
import "../styles/assignedShifts.css";
import trashbin from "../assets/trashbin.png";
import ConfirmLeaveShiftModal from "./modals/ConfirmLeaveShiftModal";

const MAX_ASSIGNED_SHIFTS = 6;

const AssignedShifts = ({ shifts = [], onLeaveShift }) => {

    // -----------------------------------------------------------
    // State für Bestätigungsmodal
    // -----------------------------------------------------------
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [selectedShiftId, setSelectedShiftId] = useState(null);

    // -----------------------------------------------------------
    // CHRONOLOGISCHE SORTIERUNG
    // -----------------------------------------------------------
    const dayOrder = ["Freitag", "Samstag", "Sonntag"];

    const sortedShifts = [...shifts].sort((a, b) => {
        const dayDiff =
            dayOrder.indexOf(a.dayOfDeployment) -
            dayOrder.indexOf(b.dayOfDeployment);

        if (dayDiff !== 0) return dayDiff;

        return (a.startTime || "").localeCompare(b.startTime || "");
    });

    // -----------------------------------------------------------
    // MAXIMAL 3 SCHICHTEN ANZEIGEN
    // -----------------------------------------------------------
    const displayShifts = sortedShifts.slice(0, MAX_ASSIGNED_SHIFTS);
    const limitReached = sortedShifts.length >= MAX_ASSIGNED_SHIFTS;

    // -----------------------------------------------------------
    // Delete geklickt → Modal öffnen
    // -----------------------------------------------------------
    const handleDeleteClick = (shiftId) => {
        setSelectedShiftId(shiftId);
        setConfirmOpen(true);
    };

    // -----------------------------------------------------------
    // Bestätigt → echte Löschaktion
    // -----------------------------------------------------------
    const confirmLeaveShift = () => {
        if (selectedShiftId != null) {
            onLeaveShift(selectedShiftId);
        }
        setConfirmOpen(false);
        setSelectedShiftId(null);
    };

    // -----------------------------------------------------------
    // Abbrechen
    // -----------------------------------------------------------
    const cancelLeaveShift = () => {
        setConfirmOpen(false);
        setSelectedShiftId(null);
    };

    return (
        <div className="assigned-column">
            <h3>Deine Schicht(en)</h3>

            {/* Hinweis bei erreichtem Limit */}
            {limitReached && (
                <p className="assigned-limit-hint">
                    Das Maximum von {MAX_ASSIGNED_SHIFTS} Schichten ist erreicht.
                </p>
            )}

            <div className="assigned-shift-grid">
                {displayShifts.length ? (
                    displayShifts.map((shift) => {

                        const deptClass = `dept-${shift.department.replace(/\s|&/g, "")}`;
                        const dayClass = `day-${shift.dayOfDeployment}`;

                        return (
                            <div
                                className={`assigned-shift-card ${deptClass} ${dayClass}`}
                                key={shift.shiftId}
                            >
                                <div className="shift-info">
                                    <h4>{shift.department}</h4>
                                    <p>{shift.dayOfDeployment}</p>
                                    <p>{shift.startTime} – {shift.endTime}</p>
                                    <p>Du bist eingeschrieben</p>
                                </div>

                                <button
                                    className="trash-btn"
                                    onClick={() => handleDeleteClick(shift.shiftId)}
                                    title="Leave shift"
                                >
                                    <img
                                        src={trashbin}
                                        className="trash-icon"
                                        alt="delete"
                                    />
                                </button>
                            </div>
                        );
                    })
                ) : (
                    <p>Zur Zeit sind keine Schichten verfügbar.</p>
                )}
            </div>

            {/* Bestätigungsmodal */}
            {confirmOpen && (
                <ConfirmLeaveShiftModal
                    onConfirm={confirmLeaveShift}
                    onCancel={cancelLeaveShift}
                />
            )}
        </div>
    );
};

export default AssignedShifts;
